import type { FC } from 'react';
import { Button, ContainedList, ContainedListItem, HeaderPanel } from '@carbon/react';
import { Add } from '@carbon/icons-react';

import { FotoDoPerfil } from './FotoDoPerfil';
import styles from './Casca.module.scss';

// SEUS PERFIS — um painel da direita do UI Shell com a lista de perfis da conta (`ContainedList`,
// que traz o próprio rótulo) e "Criar perfil" no fim. O aberto diz que está aberto (e escolhê-lo só
// fecha a lista). Só existe aberto: fechado, os perfis não entram na ordem do Tab.

export interface PerfilDoPainel {
  id: string;
  nome: string;
  imagem?: string | null;
}

export const PainelDePerfis: FC<{
  aberto: boolean;
  perfis: PerfilDoPainel[];
  atual?: string;
  aoAbrir: (id: string) => void;
  aoCriar: () => void;
}> = ({ aberto, perfis, atual, aoAbrir, aoCriar }) => (
  <HeaderPanel expanded={aberto} aria-label='Seus perfis' className={styles.painel} data-painel-de-perfis=''>
    {aberto && (
      <>
        <ContainedList label='Seus perfis' kind='disclosed'>
          {perfis.map((p) => (
            // O nome do botão é o texto dele (com o "(aberto)"): o Carbon põe os atributos no `li`, e
            // não no botão, e ali eles não são lidos.
            <ContainedListItem key={p.id} onClick={() => aoAbrir(p.id)}>
              <span className={styles.itemDePerfil}>
                <FotoDoPerfil nome={p.nome} imagem={p.imagem} className={styles.fotoDaLista} />
                <span>{p.id === atual ? `${p.nome} (aberto)` : p.nome}</span>
              </span>
            </ContainedListItem>
          ))}
        </ContainedList>
        <div className={styles.acaoDoPainel}>
          <Button kind='ghost' size='md' renderIcon={Add} onClick={aoCriar}>Criar perfil</Button>
        </div>
      </>
    )}
  </HeaderPanel>
);
